export const enum HardwareGeneration {
  ES_PLUS = 3,
  CLASSWIZ = 4,
  CLASSWIZ_II = 5,
}

export type Address24 = number;
export type Address20 = number;
export type Address16 = number;
export type Byte = number;
export type Word16 = number;
export type Word24 = number;

export class EmulatorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EmulatorError';
  }
}

export class CPUError extends EmulatorError {
  constructor(message: string) {
    super(message);
    this.name = 'CPUError';
  }
}

export class MMUError extends EmulatorError {
  constructor(message: string) {
    super(message);
    this.name = 'MMUError';
  }
}

export class ConfigError extends EmulatorError {
  constructor(message: string) {
    super(message);
    this.name = 'ConfigError';
  }
}
